<template>
  <section id="network">
    <div class="row text-center">
      <div class="col">
        <h2 class="title">
          Network
          <hr class="divider">
        </h2>
      </div>
    </div>
    <div class="row text-center">
      <div class="col">
        <h6 class="subtitle">
          Meet some of the partners and research funders we've been working with.
        </h6>
      </div>
    </div>
    <div class="row text-center mt-4 d-flex justify-content-center">
      <div
        v-for="partner in network"
        :key="partner.id"
        class="col-6 col-sm-4 col-lg-2 mb-5"
      >
        <a
          :href="partner.url"
          target="_blank"
        >
          <b-card>
            <b-card-text>
              <img
                :src="getPartnerImage(partner.img)"
                style="width: 100px; height: 100px; object-fit: contain;"
              >
            </b-card-text>
          </b-card>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import { network } from '@/configs/network'

export default {
    name: 'OurNetwork',
    data() {
        return {
            network: network
        }
    },
    methods: {
        getPartnerImage(image) {
            return require('../assets/img/network/' + image)
        }
    }
}
</script>